import { ChangePasswordForm } from '@/features/auth';

export default function ChangePasswordPage() {
  return <ChangePasswordForm />;
}
